// extracted by mini-css-extract-plugin
export default {"share":"shares_share__Zyq5f","shareOptions":"shares_shareOptions__76xWv","expired":"shares_expired__ibrJs","expireMessage":"shares_expireMessage__+JqmU"};